import React from 'react';

import { AlertParams } from 'components/WithAlert';

export default React.createContext<AlertParams>({
  onSuccess: () => {},
  onFailure: () => {},
});
